module.exports = __webpack_public_path__ + "img/img1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/img1.png
// module id = 1294
// module chunks = 0